(function () {
  if (window.ProductMediaSyncLoaded) return;
  window.ProductMediaSyncLoaded = true;

  function ready(fn) {
    if (typeof window.subscribe === 'function') {
      fn();
    } else {
      setTimeout(function () { ready(fn); }, 50);
    }
  }

  // ---------------------------------------------------------------------
  // Mobile/touch detection.
  //
  // A previous version relied solely on matchMedia('(pointer: coarse)') and
  // ('(hover: none)'). Real-device testing showed those can both evaluate
  // false on an actual iPhone -- most likely because iOS Safari's per-site
  // "Request Desktop Website" setting deliberately reports pointer:fine /
  // hover:hover to mimic a mouse-driven desktop browser, so responsive
  // sites render their desktop layout. The phone is still a touchscreen and
  // still dispatches a real touchstart for every tap; only the media-query
  // *answer* is faked. Media queries describe device capability in the
  // abstract and can be overridden -- they are not a live observation of
  // the gesture that actually triggered a given variant change.
  //
  // touchEverDetected is that live observation: a single page-lifetime
  // touchstart listener that flips true the first time any real touch is
  // observed, and can never be un-set. A tap on a color swatch always
  // dispatches touchstart before the resulting click/variant-change fires,
  // so this flag is already true by the time the variant-change subscriber
  // below runs for that same tap -- no race condition. It cannot be spoofed
  // by Request Desktop Website mode, since that mode does not (and cannot)
  // suppress real touch event dispatch.
  //
  // isMobileTouchDevice() is evaluated fresh on every variant-change event
  // rather than cached once at script load, so the answer only gets more
  // certain over time (once true, always true for the rest of the page's
  // life) and is never stuck on a stale/wrong snapshot. The media query
  // check is kept as a harmless secondary signal, OR'd in -- it can only
  // add true positives (e.g. the very first interaction on a page landed on
  // via something other than a touch, on a device that is still touch
  // primary), never cause a false one.
  // ---------------------------------------------------------------------
  var touchEverDetected = false;
  document.addEventListener('touchstart', function () {
    touchEverDetected = true;
  }, { passive: true, capture: true });

  function isMobileTouchDevice() {
    try {
      var mq = window.matchMedia('(pointer: coarse)').matches &&
               window.matchMedia('(hover: none)').matches;
      return touchEverDetected || mq;
    } catch (e) {
      return touchEverDetected;
    }
  }

  function slideMediaId(slideEl) {
    var m = slideEl.querySelector('[data-media-id]');
    return m ? m.getAttribute('data-media-id') : slideEl.getAttribute('data-media-id');
  }

  // Tracks the media id that SHOULD be showing for the currently selected
  // variant, per product-info section. Re-applied any time the gallery's
  // own Swiper instance (re)initializes, not just at the moment of variant
  // change (see the initializeSwiper patch below and the reasoning in the
  // comment above it). Still used on desktop; kept updated on mobile too as
  // an inert record (harmless -- the reinit-correction backstop below may
  // still fire on mobile, it just won't matter once a reload is in flight).
  var desiredMediaIdBySection = {};

  // Move the gallery to the slide whose nested [data-media-id] matches the
  // selected variant's featured media. Never destroys or reinitializes the
  // swiper-component; only repositions the already-live instance, or (if
  // Swiper hasn't lazily initialized yet) reorders the DOM so the correct
  // slide is first once it does. Scoped strictly to the main gallery
  // (.swiper-main); the separate thumbnail rail (.swiper-thumbs) is left
  // untouched and syncs itself via Swiper's built-in thumbs linkage.
  //
  // Verified live against this theme's bundled Swiper build: slideToLoop()
  // does not move the active slide at all (activeIndex/translate never
  // change), while plain slideTo() works correctly and consistently even
  // with loop:true. slideTo() is used as the primary method; slideToLoop()
  // is attempted only as an extra fallback in case a future Swiper update
  // changes this.
  //
  // This is the DESKTOP path (and a harmless backstop everywhere else) --
  // unchanged from the previously verified version.
  function goToMedia(swiperComponent, targetMediaId, attempt) {
    attempt = attempt || 0;
    try {
      var live = swiperComponent.initSwiper;
      if (live && live.slides && live.slides.length) {
        var realIndex = -1;
        for (var i = 0; i < live.slides.length; i++) {
          if (String(slideMediaId(live.slides[i])) === String(targetMediaId)) {
            var slideEl = live.slides[i];
            var idxAttr = slideEl.getAttribute('data-swiper-slide-index');
            realIndex = idxAttr !== null && idxAttr !== '' ? parseInt(idxAttr, 10) : i;
            break;
          }
        }
        if (realIndex === -1 || isNaN(realIndex)) return;

        if (typeof live.slideTo === 'function') {
          live.slideTo(realIndex, 0, false);
        }

        setTimeout(function () {
          try {
            if (live.destroyed) return;
            if (live.realIndex !== realIndex && live.activeIndex !== realIndex) {
              if (typeof live.slideToLoop === 'function' && live.params && live.params.loop) {
                live.slideToLoop(realIndex, 0, false);
              }
              if (live.realIndex !== realIndex && live.activeIndex !== realIndex &&
                  typeof live.slideTo === 'function' && attempt < 3) {
                live.slideTo(realIndex, 0, false);
              }
            }
          } catch (err) {
            console.error('[product-media-sync] slide verify/retry failed', err);
          }
        }, 120);
        return;
      }
    } catch (err) {
      console.error('[product-media-sync] live swiper navigation failed', err);
    }

    // No live Swiper instance yet (lazy init hasn't run). Reorder the DOM so
    // the correct slide is physically first in the main wrapper only; safe
    // because Swiper hasn't attached, so it will read this order once it does.
    try {
      var mainWrapper = swiperComponent.querySelector('.swiper-main .swiper-wrapper');
      if (!mainWrapper) {
        if (attempt < 5) {
          setTimeout(function () { goToMedia(swiperComponent, targetMediaId, attempt + 1); }, 100);
        }
        return;
      }
      var slides = Array.prototype.slice.call(mainWrapper.querySelectorAll(':scope > .swiper-slide'));
      var match = null;
      for (var j = 0; j < slides.length; j++) {
        if (String(slideMediaId(slides[j])) === String(targetMediaId)) {
          match = slides[j];
          break;
        }
      }
      if (match && mainWrapper.firstElementChild !== match) {
        mainWrapper.prepend(match);
      }
      if (attempt < 5) {
        setTimeout(function () { goToMedia(swiperComponent, targetMediaId, attempt + 1); }, 150);
      }
    } catch (err) {
      console.error('[product-media-sync] DOM reorder fallback failed', err);
    }
  }

  // The theme's own <swiper-component> lazily calls its native
  // initializeSwiper() the first time it scrolls into view, via an internal
  // IntersectionObserver, and again every subsequent time the element
  // re-enters the viewport, each time resetting the gallery to its first
  // slide. We never call initializeSwiper() ourselves; we only react after
  // the theme's own (re)initialization finishes and nudge the already-live
  // instance back to the correct slide. Unchanged from the previous version;
  // left active on mobile too as a harmless backstop.
  function patchReinitCorrection() {
    var SwiperComp = customElements.get('swiper-component');
    if (!SwiperComp || SwiperComp.prototype.__mediaSyncReinitPatched) return;
    var proto = SwiperComp.prototype;
    var original = proto.initializeSwiper;
    if (typeof original !== 'function') return;
    proto.initializeSwiper = function () {
      var result = original.apply(this, arguments);
      var swiperComponent = this;
      setTimeout(function () {
        try {
          var section = swiperComponent.closest('product-info[data-section]');
          var sectionId = section ? section.getAttribute('data-section') : null;
          var desired = sectionId ? desiredMediaIdBySection[sectionId] : null;
          if (desired) {
            goToMedia(swiperComponent, desired);
          }
        } catch (err) {
          console.error('[product-media-sync] reinit correction failed', err);
        }
      }, 80);
      return result;
    };
    proto.__mediaSyncReinitPatched = true;
  }

  // ---------------------------------------------------------------------
  // Mobile-only reload fallback.
  //
  // Real-device testing showed the dynamic Swiper sync above is not
  // reliable on iOS Safari (the image sometimes doesn't update on tap at
  // all, only after a manual refresh -- refreshing always shows the
  // correct photo because direct ?variant= URLs are already rendered
  // correctly server-side). Rather than continue chasing timing issues we
  // cannot reproduce in any available testing tool, on a real touch device
  // we perform a single real navigation to the newly selected variant's
  // URL so the server renders the correct photo directly. Desktop never
  // takes this path.
  // ---------------------------------------------------------------------

  // Captured once, from whatever URL the page first loaded with, so the
  // draft preview keeps working even if Shopify's own variant-picker code
  // later strips preview_theme_id from the address bar (relying on the
  // preview cookie instead of the query param).
  var initialPreviewThemeId = (function () {
    try {
      return new URL(location.href).searchParams.get('preview_theme_id');
    } catch (e) {
      return null;
    }
  })();

  // Reads the media id of the photo actually on screen right now, straight
  // from the DOM. On a fresh page load (or immediately after a prior mobile
  // reload) this is always correct, since it either reflects the untouched
  // server-rendered state or the state right after a full navigation. That
  // makes it a reliable way to tell a Color change (photo differs) apart
  // from a Size change (same color, same photo) without needing to parse
  // which Shopify option position corresponds to "Color".
  function getCurrentMediaId(swiperComponent) {
    var mainSwiper = swiperComponent.querySelector('.swiper-main');
    if (!mainSwiper) return null;
    var activeEl = mainSwiper.querySelector('.swiper-slide-active [data-media-id]');
    if (activeEl) return activeEl.getAttribute('data-media-id');
    // Swiper hasn't initialized yet -- the first non-duplicate slide in DOM
    // order is the server-selected current variant's photo (same assumption
    // the goToMedia DOM-reorder fallback above relies on).
    var firstEl = mainSwiper.querySelector(
      '.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate) [data-media-id]'
    );
    return firstEl ? firstEl.getAttribute('data-media-id') : null;
  }

  // Guards against reload loops:
  //   1. mobileReloadInFlight -- set synchronously before navigating, so a
  //      second variant-change event firing in the same tick is swallowed
  //      rather than triggering a second navigation.
  //   2. Never navigate to the variant already in the URL.
  //   3. Because every mobile reload lands on a fresh, server-correct page,
  //      getCurrentMediaId() is always accurate immediately afterward, so
  //      the same variant can never be misread as "changed" twice in a row.
  //      No counters or stored history are needed for this -- it falls out
  //      of the design.
  var mobileReloadInFlight = false;

  function maybeMobileReload(targetVariantId) {
    if (mobileReloadInFlight) return true;

    var currentVariantMatch = location.href.match(/[?&]variant=(\d+)/);
    var currentVariantId = currentVariantMatch ? currentVariantMatch[1] : null;
    if (String(currentVariantId) === String(targetVariantId)) return false;

    try {
      var url = new URL(location.href);
      url.searchParams.set('variant', targetVariantId);
      if (!url.searchParams.get('preview_theme_id') && initialPreviewThemeId) {
        url.searchParams.set('preview_theme_id', initialPreviewThemeId);
      }

      mobileReloadInFlight = true;
      try {
        sessionStorage.setItem('pms_mobile_reload_to', String(targetVariantId));
      } catch (e) {
        // Storage unavailable (e.g. Safari private mode) -- non-fatal, the
        // in-flight flag and URL check above are sufficient on their own.
      }

      // replace(), not assign(): avoids adding a new back-button history
      // entry, so back takes the user to wherever they were before touching
      // swatches, not to a mid-flicker intermediate state.
      location.replace(url.toString());
      return true;
    } catch (err) {
      console.error('[product-media-sync] mobile reload navigation failed', err);
      mobileReloadInFlight = false;
      return false;
    }
  }

  ready(function () {
    patchReinitCorrection();

    window.subscribe('variant-change', function (event) {
      try {
        var data = event && event.data;
        if (!data || !data.variant || !data.sectionId) return;

        var targetMediaId = data.variant.featured_media && data.variant.featured_media.id;
        if (!targetMediaId) return;

        var scope = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
        if (!scope) return;

        var swiperComponent = scope.querySelector('media-gallery > swiper-component');
        if (!swiperComponent) return;

        if (isMobileTouchDevice()) {
          var currentMediaId = getCurrentMediaId(swiperComponent);
          var colorChanged = currentMediaId != null && String(currentMediaId) !== String(targetMediaId);

          if (colorChanged) {
            var navigated = maybeMobileReload(data.variant.id);
            if (navigated) return; // page is unloading; nothing else to do
          }

          // Size-only change (or navigation was skipped for some reason):
          // no photo change is expected, so there's nothing to sync.
          desiredMediaIdBySection[data.sectionId] = targetMediaId;
          return;
        }

        // ---- Desktop: existing dynamic behavior, unchanged ----
        desiredMediaIdBySection[data.sectionId] = targetMediaId;
        goToMedia(swiperComponent, targetMediaId);
      } catch (err) {
        console.error('[product-media-sync] failed to sync gallery image on variant change', err);
      }
    });
  });
})();